exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-47853f8d]{font-size:14px;margin-top:12px}table[data-v-47853f8d],td[data-v-47853f8d],tr[data-v-47853f8d]{border-collapse:collapse}td[data-v-47853f8d]{padding-left:2px}th[data-v-47853f8d]{text-align:left;padding-left:1px;background-color:#d3d3d3}@page{size:landscape}@media print{#printbtn[data-v-47853f8d]{display:none}}.btn[data-v-47853f8d]{background-color:#438eb9;color:#fff;padding-top:4px;padding-bottom:4px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47853f8d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fee/adjustmentChallanPrint.vue
// module id = 537
// module chunks = 0